import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const addWidthToCdnUrl = (url, width) => {
  if (!url.includes("cdn.")) return url;

  const param = `width=${width}`;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${param}`;
};

export const Image = ({src, alt = null, width = null }) => (
  <LazyLoadImage src={addWidthToCdnUrl(src, width)} alt={alt} />
);

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
};